import { render } from "./Wheel.vue?vue&type=template&id=814a6184&scoped=true"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import "./Wheel.vue?vue&type=style&index=0&id=814a6184&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-814a6184"

export default script